import { MarkerContextProvider } from 'features/pointClouds/state/MarkerContext'
import { DefaultPointCloudContextProvider } from 'features/pointClouds/state/PointCloudContext'
import React, { createContext, useContext } from 'react'

interface PointCloudParamsContextType {
  siteId?: string
  pointCloudIDs?: string[]
}

export const PointCloudParamsContext = createContext<
  PointCloudParamsContextType | undefined
>(undefined)

export const usePointCloudParams = () => {
  return useContext(PointCloudParamsContext)
}

interface PointCloudContextProviderProps {
  siteId: string
  pointCloudIDs?: string[]
  children: React.ReactNode
}

export const PointCloudContextProvider: React.FC<
  PointCloudContextProviderProps
> = ({ siteId, pointCloudIDs, children }) => {
  const contextValue: PointCloudParamsContextType = {
    siteId: siteId,
    pointCloudIDs,
  }

  return (
    <PointCloudParamsContext.Provider value={contextValue}>
      <MarkerContextProvider>
        <DefaultPointCloudContextProvider>
          {children}
        </DefaultPointCloudContextProvider>
      </MarkerContextProvider>
    </PointCloudParamsContext.Provider>
  )
}
